import { render } from "./InformationDialog.vue?vue&type=template&id=d585b97c&scoped=true"
import script from "./InformationDialog.vue?vue&type=script&lang=js"
export * from "./InformationDialog.vue?vue&type=script&lang=js"

import "./InformationDialog.vue?vue&type=style&index=0&id=d585b97c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d585b97c"]])

export default __exports__